import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LetsCollaborate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21814" id="start-your-transformation" className="relative overflow-hidden bg-emerald-950 py-32 md:py-48">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/tara_trebesch_logo_watermark.png" alt="" className="w-[150%] max-w-none md:w-[80%] opacity-[0.05] object-contain grayscale invert" aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={cn("container relative z-10 mx-auto px-6 text-center transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="font-sans font-bold text-4xl md:text-7xl lg:text-8xl text-white mb-12 tracking-tighter">
          Ready to Scale?
        </h2>
        
        <div className="flex justify-center">
          <Button asChild size="lg" className="h-14 px-10 text-lg rounded-none bg-emerald-500 text-white hover:bg-emerald-400 shadow-[0_2px_0_0_rgba(0,0,0,0.2)] active:shadow-none transition-all duration-400">
            <Link to="/ConsultationPage">Get Started</Link>
          </Button>
        </div>
      </div>
    </section>;
}